import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ServiceBase } from './service.base';
import { INTERCEPTNotFound } from '../../core/interceptors/contexts';

@Injectable({
  providedIn: 'root',
})
export class AgrirouterService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  onboard(signature: string, state: string, token: string): Observable<any> {
    const body = { signature, state, token };
    return this.http
      .post(`${this.UrlServiceV1}onboard-account`, body, this.obterAuthHeader())
      .pipe(catchError(this.serviceError));
  }
  getOnboardAuthObject(
    initialURL: string,
  ): Observable<{ authorizationUrl: string; state: string }> {
    return this.http
      .get<{ authorizationUrl: string; state: string }>(initialURL)
      .pipe(catchError(this.serviceError));
  }

  getAgrirouterFiles(): Observable<{
    files: any;
  }> {
    return this.http
      .get<{
        files: any;
      }>(`${this.UrlServiceV1}list-agrirouter-files`, this.obterAuthHeader())
      .pipe(catchError(this.serviceError));
  }

  checkOnboardStatus(): Observable<{
    message: string;
    onboarded: boolean;
    data: any;
  }> {
    return this.http
      .get<{
        message: string;
        onboarded: boolean;
        data: any;
      }>(`${this.UrlServiceV1}onboard-account`, this.obterAuthHeader())
      .pipe(catchError(this.serviceError));
  }
  getEndpointList(
    serialNumber: string,
    fileType: string = 'taskdata',
  ): Observable<{ message: string; endpoints: any }> {
    const options = {
      ...this.obterAuthHeader(),
      context: new HttpContext().set(INTERCEPTNotFound, false),
    };
    return this.http
      .get<{
        message: string;
        endpoints: any;
      }>(
        `${this.UrlServiceV1}list-endpoints?deviceId=${serialNumber}&fileType=${fileType}`,
        options,
      )
      .pipe(catchError(this.serviceError));
  }
  getAllDevicesConnectedToAgrirouter(): Observable<any> {
    return this.http
      .get<any>(`${this.UrlServiceV1}onboard-vcu`, this.obterAuthHeader())
      .pipe(catchError(this.serviceError));
  }
  onboardVCU(
    deviceId: string,
  ): Observable<{ message: string; onboarded: boolean }> {
    if (!deviceId || deviceId.trim() === '') {
      throw new Error('deviceId must be a non-empty string');
    }
    return this.http
      .post<{
        message: string;
        onboarded: boolean;
      }>(
        `${this.UrlServiceV1}onboard-vcu/${deviceId}`,
        null,
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }
  offBoardVCU(
    deviceId: string,
  ): Observable<{ message: string; onboarded: boolean }> {
    if (!deviceId || deviceId.trim() === '') {
      throw new Error('deviceId must be a non-empty string');
    }
    return this.http
      .post<{
        message: string;
        onboarded: boolean;
      }>(
        `${this.UrlServiceV1}offboard-vcu/${deviceId}`,
        null,
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }
  offBoardUser(): Observable<{ message: string; onboarded: boolean }> {
    return this.http
      .post<{
        message: string;
        onboarded: boolean;
      }>(`${this.UrlServiceV1}offboard-account`, null, this.obterAuthHeader())
      .pipe(catchError(this.serviceError));
  }
  sendTaskdata(
    deviceId: string,
    data: any,
  ): Observable<{ message: string; onboarded: boolean }> {
    if (!deviceId || deviceId.trim() === '') {
      throw new Error('deviceId must be a non-empty string');
    }
    return this.http
      .post<{
        message: string;
        onboarded: boolean;
      }>(
        `${this.UrlServiceV1}send-taskdata/${deviceId}`,
        { data },
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }
  sendShapefile(
    deviceId: string,
    data: any,
  ): Observable<{ message: string; onboarded: boolean }> {
    if (!deviceId || deviceId.trim() === '') {
      throw new Error('deviceId must be a non-empty string');
    }
    return this.http
      .post<{
        message: string;
        onboarded: boolean;
      }>(
        `${this.UrlServiceV1}send-shapefile/${deviceId}`,
        { data },
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }

  getShapefiles(): Observable<{}> {
    return this.http
      .post<{}>(
        `${this.UrlServiceV1}fetch-shapefiles`,
        {},
        this.obterAuthHeader(),
      )
      .pipe(catchError(this.serviceError));
  }

  pingEndpoint(): Observable<{
    connected: boolean;
    deleted?: boolean;
    message: string;
  }> {
    const options = {
      ...this.obterAuthHeader(),
      context: new HttpContext().set(INTERCEPTNotFound, false),
    };
    return this.http
      .get<{
        connected: boolean;
        deleted?: boolean;
        message: string;
      }>(`${this.UrlServiceV1}ping-endpoint`, options)
      .pipe(catchError(this.serviceError));
  }
}
